import Vue from "vue";
import VueRouter from "vue-router";
import TheMapPage from "@/pages/MapPage/TheMapPage.vue";
import TheMapCatalogue from "@/pages/CataloguePage/TheCataloguePage.vue";

Vue.use(VueRouter);

export default new VueRouter({
  base: "/",
  mode: "history",
  routes: [
    process.env.VUE_APP_USE_SINGLE_PROFILE
      ? {
          path: "/",
          redirect: {
            name: "tema",
            params: { id: process.env.VUE_APP_USE_SINGLE_PROFILE },
          },
        }
      : { path: "/", component: TheMapCatalogue, name: "hovedside" },
    { path: "/link/:parameters?", component: TheMapPage, name: "link" },
    { path: "/map", component: TheMapPage, name: "kart" },
    {
      path: "/tema/:id",
      component: TheMapPage,
      props: true,
      name: "tema",
    },
    {
      path: "/prosjekt/:projectId/:editHash?",
      component: TheMapPage,
      props: true,
      name: "prosjekt",
    },
  ],
});
